import { Link } from 'react-router-dom';
import {
  useDeleteTeacherRequestMutation,
  useGetTeacherRequestsQuery,
} from '@/entities/TeacherRequests';
import TrashIcon from '@/shared/assets/icons/trash.svg';
import { Svg } from '@/shared/ui/Svg';
import {
  TEACHER_REQUEST_REASON_LABELS,
  TEACHER_REQUEST_STATUS_CLASSES,
  TEACHER_REQUEST_STATUS_LABELS,
  formatRequestDate,
} from './teacherRequestUi';

export const TeacherRequests = () => {
  const { data: requests = [], isLoading } = useGetTeacherRequestsQuery();
  const [deleteTeacherRequest] = useDeleteTeacherRequestMutation();

  if (isLoading) {
    return <div className="py-8 text-center text-grey-secondary">Loading requests...</div>;
  }

  if (!requests.length) {
    return (
      <div className="flex flex-col gap-4 py-1">
        <p className="text-base font-semibold text-[#667085]">No requests found</p>
        <p className="text-base text-grey-secondary">
          Once you submit a request, it will appear here
        </p>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-xl border border-[#D9DDE6]">
      <table className="w-full border-collapse">
        <caption className="sr-only">Requests from students</caption>
        <thead>
          <tr className="h-14 bg-white text-left text-sm font-semibold text-[#667085]">
            <th scope="col" className="px-6">
              Date
            </th>
            <th scope="col" className="px-6">
              Reason
            </th>
            <th scope="col" className="px-6">
              Closed
            </th>
            <th scope="col" className="w-14 px-4">
              <span className="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {requests.map((request) => (
            <tr
              key={request.id}
              className={`h-[72px] border-t border-[#D9DDE6] text-base ${
                request.status === 'approved'
                  ? 'bg-[#E7F7EF]'
                  : request.status === 'rejected'
                    ? 'bg-[#FBE4E4]'
                    : 'bg-white'
              }`}
            >
              <td className="px-6">
                <Link to={`/profile/teacher/requests/${request.id}`} className="block">
                  {formatRequestDate(request.createdAt)}
                </Link>
              </td>
              <td className="px-6">
                <Link to={`/profile/teacher/requests/${request.id}`} className="block">
                  {TEACHER_REQUEST_REASON_LABELS[request.reason]}
                </Link>
              </td>
              <td className="px-6">
                <Link to={`/profile/teacher/requests/${request.id}`} className="block">
                  {request.resolvedAt ? (
                    formatRequestDate(request.resolvedAt)
                  ) : (
                    <span
                      className={`rounded-md px-2 py-1 text-sm font-medium ${TEACHER_REQUEST_STATUS_CLASSES[request.status]}`}
                    >
                      {TEACHER_REQUEST_STATUS_LABELS[request.status]}
                    </span>
                  )}
                </Link>
              </td>
              <td className="px-4">
                {request.status === 'new' && (
                  <button
                    type="button"
                    aria-label="Delete request"
                    className="cursor-pointer p-2"
                    onClick={() => deleteTeacherRequest(request.id)}
                  >
                    <Svg Icon={TrashIcon} className="h-5 w-5 text-grey-secondary" />
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
